import ImagePlacer from './ImagePlacer'

export default ImagePlacer


// WEBPACK FOOTER //
// ./src/board/ImagePlacer/index.js